// libs
import { styled } from '@nykaa/ui-components';

// mixins
import { resetButton } from 'shared/styles/mixin';

import Plus from '@nykaa/ui-components/Icons/plus';

export const Container = styled.div``;

export const Button = styled.button`
  ${resetButton}

  position: relative;
  display: block;
  width: 100%;
  text-align: left;
  
  &:focus-visible {
    outline: 1px solid ${({ theme }) => theme.colors.secondary};
    outline-offset: -2px;
  }
`;

export const ExpanderIcon = styled(Plus)`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 11px;
  height: 11px;
`;

export const Content = styled.div`
  overflow: hidden;
  transition: height 0.25s linear;
`;
